var LogLevel;
(function (LogLevel) {
    LogLevel["error"] = "error";
    LogLevel["warn"] = "warn";
    LogLevel["stub"] = "stub";
    LogLevel["info"] = "info";
})(LogLevel || (LogLevel = {}));
const makeLogger = (gba, watchLogLevels, callback) => (level, message) => {
    if (level === LogLevel.error) {
        gba.pause();
    }
    if (watchLogLevels[level] === false || watchLogLevels[level] === undefined) {
        return;
    }
    callback(level, message);
};
export { LogLevel, makeLogger };
